export enum MuiTableCellEnum {
  Id = 'id',
  Error = 'error',
  ClassName = 'className',
  HasError = 'hasError',
}
